<lib-comments-list
  (updateLastSeen)="updateLastSeen($event)"
  [comments]="commentsList$ | async"
  [isSolo]="isSolo$ | async"
  [lastSeen]="$safeNavigationMigration((conversationStatus$ | async)?.lastSeen)"
></lib-comments-list>
<lib-component-form-field
  (addComment)="addComment($event)"
  (draftDirtyChange)="draftDirtyChange.emit($event)"
></lib-component-form-field>
